import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";

function JoinauctionCode(match) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [joindata, setjoindata] = useState([]);
  const [isActive, setActive] = useState(false);
  const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const [isDisabled, setDisabled] = useState(false);
  const refresh = useSelector((state) => state.setRefresh);
  const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);

  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };
    //  console.log("")
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
      

        toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response, values }));
        //  console.log('code sub resp.......')
        //  console.log(response)

        if (response.success == true) {
          if(response.data.detail.reg_player_on === "1"){
            //  console.log("code submit")
            //  console.log(response.data)
            localStorage.setItem("auction_id", response.data.detail.aid);

            toast.success("Now you can Join", {
              theme: "dark",
              position: "bottom-center",
            });
            history.push(BASE_PATH + "join-auction");
          }
          else{
            setjoindata(response.data.detail)
          }
          
          
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        // setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
    localStorage.removeItem('acode')
  };

  const fetchData = async () => {
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.getJoinAuction({ ucid: cid }, hdr)
      .then((res) => {
        let response = res.data;
     
        if (response.success == true) {
          let responsedata = response.data;
          //  console.log(responsedata)
          setData(responsedata);
          // dispatch(actlistData({ responsedata }));
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };

  const setauction = (ai, an) => {
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_name", an);
  };

  useEffect(() => {
    if (refresh == 1) {

      fetchData(0);
    } else {
      if (getpageData == 0) {
              
        fetchData(0);
      } else {
        if (getpageData.responsedata.cid == cid) {
       
          fetchData(0)
          // setData(getpageData.responsedata);
        } else {
          let responsedata = getpageData.responsedata;
          responsedata.list = [];
          // setData(responsedata);
          fetchData(0);
        }
      }
    }
    if (localStorage.getItem('acode')) {
      var values = {
        'acode': localStorage.getItem('acode')
      }
      onSubmit(values);

    }

    window.scrollTo(0, 0);
  }, [refresh]);
  function choosedauction(code) {
    var values = {
      'acode': code
    }
    onSubmit(values);
  }
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        <div>
          <Navigationtitle data={match} />
          <div id="top-categories" className="top-cat-area  bottom-less">
            <div className="container-fluid padding-left-0px">
              <section className="event-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="event-items">
                      <div className="item vertical">
                        <div className="join-auction-form col-md-12">
                          <div className="col-md-4">
                            <h3>Enter Code for Join Auction</h3>
                          </div>

                          <form
                            onSubmit={handleSubmit(onSubmit)}
                            action=""
                            autoComplete="off"
                            encType="multipart/form-data"
                          >
                            <div className="col-md-4">
                              <div className="form-group">
                                <input
                                  className="form-control"
                                  type="text"
                                  {...register("acode", {
                                    required: true,
                                    required: "required field.",
                                  })}
                                />
                                {errors.acode && (
                                  <p className="text-error">
                                    {errors.acode.message}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <button
                                  className="button"
                                  type="submit"
                                  style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    padding: "3px",
                                    fontSize: "20px",
                                  }}
                                >
                                  {" "}
                                  GO
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    {joindata !="" &&   <> <div className="col-md-6 join-auction-info">
                     
                      <div className="myr">
                        <div className="row">
                          <div className="col-md-2 join-auction-padding">
                            <Image
                              fallback={
                                <Shimmer width={50} height={50} />
                              }
                              src={
                                joindata && joindata.alogo != null
                                  ?
                                  auctiondefaultLogo
                                  // getpageData.response.data.detail.path
                                  // .getpageData.response.data.detail
                                  // .alogo
                                  : auctiondefaultLogo
                              }
                            ></Image>
                          </div>

                          <div className="col-md-10">
                            <h5>{joindata.auctionname} </h5>
                            <p>Auction on : {joindata.dt}</p>
                          </div>
                         
                        </div>
                        <div className="selfoff"><b> Registration Closed ! </b></div>
                        </div>
                       
                     
                    </div>
                    </>}
                   {data !="" ?<div className="col-md-12">
                      {" "}
                      <h3
                        style={{
                          textAlign: "center",
                          fontWeight: "700",
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          color: "#676767",
                        }}
                      >
                        You have Joined these Auction
                      </h3>
                    </div> :
                    <div className="col-md-12">
                    {" "}
                    <h3
                      style={{
                        textAlign: "center",
                        fontWeight: "700",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        color: "#676767",
                      }}
                    >
                      You haven't join any Auction yet
                    </h3>
                  </div>
                    }

                    {data != "" ? (
                      data.list?.map((dt, key) => {
                        //  console.log(dt)
                        return (
                          <>
                            <div className="item vertical col-md-4 margin-12px width-100per joinauclist">
                              <div className="my-acution-top-box-shadow ">
                                <div className="my-acution-top-top-text">
                                  A Code {dt.acode}
                                </div>
                                <div className="my-acution-top-bottom">
                                  <div className="my-acution-top-bottom-logo">
                                    {" "}
                                    {/* <Image
                                      fallback={
                                        <Shimmer
                                          className="shimmer"
                                          width={50}
                                          height={50}
                                        />
                                      }
                                      src={
                                        dt.logo == ""
                                          ? auctiondefaultLogo
                                          : data.path + dt.logo
                                      }
                                    ></Image> */}
                                    <img
                                      src={
                                        (dt.logo == "" || dt.logo==null)
                                          ? auctiondefaultLogo
                                          : data.path + dt.logo
                                      }
                                      alt="logo"
                                      // style={{ height: "40px" }}
                                    />
                                  </div>
                                  <div className="my-acution-top-bottom-content joiauccontent">
                                    <div className="my-acution-top-bottom-content-text">
                                      {" "}
                                      <Link
                                        title={dt.aname}
                                        onClick={() =>
                                          choosedauction(dt.acode)
                                        }

                                      >
                                        {maxStringNew(dt.auctionname)}
                                      </Link>
                                    </div>
                                    <div>
                                      {" "}
                                      <h5>
                                        {" "}
                                        <AiIcons.AiOutlineCalendar
                                          style={{
                                            fontSize: "16px",
                                            top: 3,
                                            position: "relative",
                                            color: "#186CC2",
                                          }}
                                        />{" "}
                                        {dt.dt}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <NotFound data={isActive} />
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default JoinauctionCode;
